import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopimprichichwadcab() {



const cardData = {
  keyword: " Mumbai to Pimpri Chinchwad Cab ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Pimpri Chinchwad cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Mumbai to Pimpri Chinchwad convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai to Pimpri Chinchwad cab travel.",

topPlaces: [
 
  {
    title: "Khandala",
    description: "Khandala is a picturesque hill station offering lush green valleys, mountain views, and peaceful surroundings. Visitors can enjoy viewpoints like Tiger's Leap and Duke’s Nose along with refreshing weather."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a coastal town known for its clean beaches, seaside forts, and relaxed atmosphere. It is ideal for beach outings, water sports, and short ferry rides from Mumbai."
  },
  {
    title: "Matheran",
    description: "Matheran is a unique eco-friendly hill station where vehicles are banned, offering serene walking trails, viewpoints, toy train rides, and panoramic views of the Western Ghats."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station famous for its strawberry farms, lush forests, viewpoints, and pleasant climate. Visitors can explore Venna Lake, Arthur’s Seat, and scenic waterfalls."
  },
   {
    title: "Lonavala",
    description: "Lonavala is a famous hill station near Mumbai known for its misty valleys, waterfalls, caves, and scenic viewpoints. It is a popular weekend getaway for trekking, nature walks, and monsoon road trips."
  },
  {
    title: "Igatpuri",
    description: "Igatpuri is a tranquil hill town known for its misty mountains, waterfalls, and the famous Vipassana meditation center. It is perfect for nature lovers and peace seekers."
  },
  {
    title: "Nashik",
    description: "Nashik is a spiritual and wine capital of India, known for Trimbakeshwar Temple, Sula Vineyards, and the Godavari River ghats. It blends pilgrimage, culture, and modern wine tourism."
  },
  {
    title: "Karjat",
    description: "Karjat is a scenic countryside destination near Mumbai known for trekking trails, rivers, waterfalls, and farm stays. It is ideal for adventure activities and peaceful weekend getaways."
  },
  {
    title: "Lavasa",
    description: "Lavasa is a planned hill city inspired by Italian towns, offering lakeside promenades, colorful architecture, and leisure activities. It is popular for relaxing drives and photography."
  },
  {
    title: "Pune",
    description: "Pune is a vibrant city known for its cultural heritage, educational institutions, forts, and modern lifestyle. Nearby attractions include Sinhagad Fort, hill stations, and historic landmarks."
  }
],



services: [
{
name: "Mumbai to Pimpri Chinchwad Cab",
description: "Mumbai to Pimpri Chinchwad cab service offers reliable intercity transportation between Mumbai and the PCMC area including Pimpri, Chinchwad, and Akurdi. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth travel via the Mumbai–Pune Expressway. Professional drivers provide punctual pickup from homes, offices, hotels, railway stations, and airport terminals across Mumbai."
},
{
name: "Mumbai to Pimpri Akurdi Cab",
description: "Mumbai to Pimpri Akurdi cab service provides convenient transportation between Mumbai city and Akurdi in Pimpri Chinchwad. Comfortable vehicles ensure safe and relaxed highway travel suitable for business and family trips."
},
{
name: "Mumbai Airport to Pimpri Chinchwad",
description: "Mumbai Airport to Pimpri Chinchwad cab service offers dependable airport transfers from Chhatrapati Shivaji Maharaj International Airport to the PCMC region. Vehicles provide comfortable seating and luggage space suitable for airport travel."
},
{
name: "Mumbai to Pimpri Chinchwad One Way Cab",
description: "Mumbai to Pimpri Chinchwad one way cab service offers economical single-trip transportation without return charges. Comfortable vehicles ensure smooth expressway travel between Mumbai and PCMC."
},
{
name: "Mumbai to Pimpri Chinchwad Taxi Fare",
description: "Mumbai to Pimpri Chinchwad taxi fare service provides transparent pricing details for travelers planning trips between Mumbai and Pimpri Chinchwad."
},
{
name: "Dadar to Pimpri Chinchwad Cab",
description: "Dadar to Pimpri Chinchwad cab service provides reliable transportation between central Mumbai and the PCMC region with comfortable vehicles and professional drivers."
},
{
name: "Andheri to Pimpri Chinchwad Cab",
description: "Andheri to Pimpri Chinchwad cab service offers dependable intercity transportation between Mumbai’s Andheri area and Pimpri Chinchwad."
},
{
name: "Mumbai to Pimpri Chinchwad Innova Cab",
description: "Mumbai to Pimpri Chinchwad Innova cab service provides premium SUV transportation with spacious seating and comfortable highway travel."
},
{
name: "Mumbai to Pimpri Chinchwad Ertiga Cab",
description: "Mumbai to Pimpri Chinchwad Ertiga cab service offers comfortable 7-seater SUV transportation suitable for families and group travel."
},
{
name: "Mumbai to Pimpri Chinchwad Taxi Fare",
description: "Mumbai to Pimpri Chinchwad taxi fare provides clear fare details for passengers traveling between Mumbai and the PCMC area."
},
{
name: "Mumbai to Baner Cab",
description: "Mumbai to Baner cab service offers reliable intercity transportation between Mumbai and Baner in Pune with comfortable vehicles."
},
{
name: "Mumbai to Wakad Cab",
description: "Mumbai to Wakad cab service provides convenient transportation between Mumbai and Wakad in Pimpri Chinchwad with smooth expressway travel."
},
{
name: "Mumbai Airport to Pune Taxi Fare",
description: "Mumbai Airport to Pune taxi fare service provides transparent pricing for passengers traveling from Mumbai Airport to Pune city."
},
{
name: "Mumbai to Akurdi Cab",
description: "Mumbai to Akurdi cab service offers dependable transportation between Mumbai and Akurdi in Pimpri Chinchwad with comfortable vehicles."
},
{
name: "Mumbai to Pune Cab Booking",
description: "Mumbai to Pune cab booking service allows passengers to easily reserve taxis for intercity travel between Mumbai and Pune."
},
{
name: "Taxi Services in Mumbai Central Station",
description: "Taxi services in Mumbai Central Station provide convenient transportation for railway passengers heading to various destinations including Pune and Pimpri Chinchwad."
},
{
name: "Best Cabs in Pune",
description: "Best cabs in Pune provide reliable transportation services for city rides, airport transfers, and outstation travel with comfortable vehicles."
},
{
name: "Mumbai to Pimpri Chinchwad Taxi",
description: "Mumbai to Pimpri Chinchwad taxi service offers convenient intercity transportation between Mumbai and PCMC with comfortable vehicles."
},
{
name: "Mumbai to Pimpri Chinchwad Cab Service",
description: "Mumbai to Pimpri Chinchwad cab service provides dependable travel options between Mumbai and Pimpri Chinchwad with experienced drivers."
},
{
name: "Mumbai to Pimpri Chinchwad Taxi Service",
description: "Mumbai to Pimpri Chinchwad taxi service offers safe and comfortable transportation for passengers traveling between Mumbai and the PCMC area."
},
{
name: "Mumbai to Pimpri Chinchwad Cab Booking",
description: "Mumbai to Pimpri Chinchwad cab booking service allows passengers to easily reserve taxis for intercity travel between Mumbai and Pimpri Chinchwad."
}
],

tableData: [
["Mumbai to Pimpri Chinchwad Cab","Mumbai to Pimpri Akurdi Cab"],
["Mumbai Airport to Pimpri Chinchwad","Mumbai to Pimpri Chinchwad One Way Cab"],
["Mumbai to Pimpri Chinchwad Taxi Fare","Dadar to Pimpri Chinchwad Cab"],
["Andheri to Pimpri Chinchwad Cab","Mumbai to Pimpri Chinchwad Innova Cab"],
["Mumbai to Pimpri Chinchwad Ertiga Cab","Mumbai to Pimpri Chinchwad Taxi Fare"],
["Mumbai to Baner Cab","Mumbai to Wakad Cab"],
["Mumbai Airport to Pune Taxi Fare","Mumbai to Akurdi Cab"],
["Mumbai to Pune Cab Booking","Taxi Services in Mumbai Central Station"],
["Best Cabs in Pune","Mumbai to Pimpri Chinchwad Taxi"],
["Mumbai to Pimpri Chinchwad Cab Service","Mumbai to Pimpri Chinchwad Taxi Service"],
["Mumbai to Pimpri Chinchwad Cab Booking","Mumbai to Pimpri Chinchwad Cab"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Mumbai to Pimpri Chinchwad via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Mumbai to Pimpri Chinchwad cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Pimpri Chinchwad cab service operates 24 hours a day. Whether you need an early morning ride, business travel, or late night drop, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Mumbai to Pimpri Chinchwad."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, airports, railway stations, and residential areas across Mumbai including Andheri, Bandra, Borivali, Thane, Navi Mumbai, and Dadar."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai to Pimpri Chinchwad cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Pimpri Chinchwad cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Mumbai to Pimpri Chinchwad with professional drivers and comfortable vehicles." },
  { question: "How far is Pimpri Chinchwad from Mumbai?", answer: "The road distance between Mumbai and Pimpri Chinchwad is approximately 135–145 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Mumbai to Pimpri Chinchwad cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Mumbai to Pimpri Chinchwad travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Mumbai to Pimpri Chinchwad?", answer: "Yes, we provide both one-way and round-trip cab services between Mumbai and Pimpri Chinchwad." },
  { question: "Do you provide pickup from Mumbai Airport?", answer: "Yes, our drivers provide pickup from Mumbai Airport, homes, hotels, offices, and railway stations across Mumbai." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai to Pimpri Chinchwad cab services online or through phone booking." },
  { question: "Do you provide drop service anywhere in Pimpri Chinchwad?", answer: "Yes, Velocity Cabs provides drop services across Pimpri Chinchwad including Pimpri, Chinchwad, Wakad, Nigdi, Bhosari, and nearby areas." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Patil",
    feedback:
      "A very smooth and comfortable journey from Mumbai to Pimpri Chinchwad. The cab was on time, well-maintained, and the ride felt relaxed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "The Mumbai to Pimpri Chinchwad cab experience was excellent. The vehicle was clean, the drive was steady, and everything was handled in a professional and hassle-free way.",
    rating: 5
  }
];


































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pimpri Chinchwad Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Mumbai to Pimpri Chinchwad cab service with affordable fares and professional drivers. Book one way and round trip taxis including Innova, Innova Crysta, Ertiga, and Sedan cabs for airport transfers, city-to-city travel, and corporate trips. Enjoy safe, comfortable, and punctual rides with easy online booking from Mumbai to Pimpri Chinchwad.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};








  return (
    <div>
      <Helmet>
  <title>Mumbai to Pimpri Chinchwad Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pimpri Chinchwad cab with Velocity Cabs. Affordable one way & round trip taxis including Innova, Innova Crysta, Ertiga & Sedan for airport transfers, city-to-city travel & corporate trips." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/39.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopimprichichwadcab;